// Utility to get asset paths from Rails
export const getAssetPaths = () => {
  const assetPathsElement = document.getElementById('asset-paths');
  if (assetPathsElement) {
    try {
      return JSON.parse(assetPathsElement.textContent);
    } catch (e) {
      console.error('Failed to parse asset paths:', e);
      return {};
    }
  }
  return {};
};

// Get specific asset path
export const getAssetPath = (key) => {
  const paths = getAssetPaths();
  return paths[key] || '';
};